import styled from 'styled-components';
import { THEME } from '../../../../../../themes';
import { Body2Font } from '../../../../../../themes/fonts';

export const CompanyHeaderWrapper = styled.div`
  margin-top: ${THEME.SPACING.TINY};
`;

export const CompanyDescription = styled.div`
  font: ${Body2Font};
  opacity: ${THEME.OPACITY.MED};
  margin: ${THEME.SPACING.TINO} 0;
`;

export const NoDescriptionFallback = styled.div`
  margin-top: ${THEME.SPACING.TINO};
`;

export const ExperienceLabel = styled.div`
  ${Body2Font};
  font-weight: 600;
  display: inline;
  color: ${THEME.COLORS.PRIMARY_DARK};
  word-break: break-word;
  margin-bottom: ${THEME.SPACING.TINY};
  max-width: 613px;
  background: ${THEME.COLORS_RGB.ACCENT_DIVIDER};
  padding-top: 2px;
  padding-bottom: 2px;
  box-shadow: 10px 0 0 ${THEME.COLORS_RGB.ACCENT_DIVIDER},
   -10px 0 0 ${THEME.COLORS_RGB.ACCENT_DIVIDER};
`;

export const Wrapper = styled.div`
  padding-left: 10px;
  margin-bottom: ${THEME.SPACING.TINO};
`;
